import React from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import { CheckboxField } from "cxa-form-field";
import { renderField, RadioButtonGroupRow, GroupTableRowField } from "./components";
import { validateRequired } from "./validation";

const moreInfoData = {
  id: "MoreInfo",
  rows: [1, 2, 3, 4],
  cols: [
    {
      name: "SubQNo",
      type: "text",
      label: "SubQNo",
      style: { width: 30 },
    },
    {
      name: "Name",
      type: "text",
      label: "Name",
      style: { width: 150 },
    },
    {
      name: "Diagnosis",
      type: "textarea",
      label: "Diagnosis",
    },
    {
      name: "From",
      type: "text",
      label: "From",
      style: { width: 100 },
    },
    {
      name: "To",
      type: "text",
      label: "To",
      style: { width: 100 },
    },
    {
      name: "MedicalProvider",
      type: "textarea",
      label: "MedicalProvider",
    },
  ],
};

const StyledForm = ({ renderValue }) => (
  <div>
    <table className="hdf-header">
      <tbody>
        <tr>
          <td className="hdf-header__logo">
            <img
              width="169"
              src="http://www.tokiomarine.com/content/dam/asia/About%20Us/Our%20Story/xtmi_group_symbol_v_1_rgb_s.jpg.pagespeed.ic.YG7q0uVA0q.webp"
              alt=""
            />
          </td>
        </tr>
        <tr>
          <td className="hdf-header__title">
            {[
              "HEALTH DECLARATION FORM FOR GROUP INSURANCE – Employee & ",
              'Dependant ("Form")',
            ].join("")}
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <table className="warning-table">
      <tbody>
        <tr>
          <td className="warning-table__header">WARNING:</td>
          <td className="warning-table__cell">
            PURSUANT TO SECTION 25(5) OF THE INSURANCE ACT, CHAPTER 142, YOU ARE TO DISCLOSE IN THIS
            FORM, FULLY AND FAITHFULLY, ALL THE FACTS WHICH YOU KNOW OR OUGHT TO KNOW, OTHERWISE YOU
            MAY RECEIVE NOTHING FROM THE POLICY.
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <div>
      {[
        "You must complete this Form as a condition precedent to the granting ",
        'of insurance under Group Policy (collectively, "Policies" and each a ',
        '"Policy") proposed by:',
      ].join("")}
    </div>
    <table>
      <tbody>
        <tr>
          <td>Name of Company: </td>
          <td className="text-field__underline">
            {renderValue({
              fieldName: "CompanyName",
              fieldFormat: "text",
            })}
          </td>
          <td className="text-field__padding">Policy No: </td>
          <td className="text-field__underline">
            {renderValue({
              fieldName: "PolicyNumber",
              fieldFormat: "text",
            })}
          </td>
        </tr>
      </tbody>
    </table>
    &nbsp;
    <br />
    <p>
      <strong>(1)&nbsp;&nbsp;&nbsp;&nbsp;PARTICULARS OF LIFE TO BE ASSURED (EMPLOYEE)</strong>
    </p>
    <table className="hdf-table">
      <tbody>
        <tr>
          <td colSpan={3}>
            Full Name (As shown in IC - Underline Surname)
            <br />
            <div className="hdf-table__cell" id="RO_EmployeeName">
              {renderValue({
                fieldName: "EmployeeName",
                fieldFormat: "text",
              })}
              <input type="hidden" name="EmployeeName" id="EmployeeName" />
            </div>
          </td>
          <td>
            <div className="hdf-table__header">Sex</div>
            <div className="hdf-table__cell hdf-table__cell--center" id="RO_Gender">
              {renderValue({
                fieldName: "Gender",
                fieldFormat: "text",
              })}
              <input type="hidden" name="Gender" id="Gender" />
            </div>
          </td>
          <td>
            <div className="hdf-table__header">NRIC / FIN No</div>
            <div className="hdf-table__cell hdf-table__cell--center" id="RO_Identification">
              {renderValue({
                fieldName: "Identification",
                fieldFormat: "text",
              })}
              <input type="hidden" name="Identification" id="Identification" />
            </div>
          </td>
          <td>
            <div className="hdf-table__header">Marital Status</div>
            <div className="hdf-table__cell hdf-table__cell--center" id="RO_MaritalStatus">
              {renderValue({
                fieldName: "MaritalStatus",
                fieldFormat: "text",
              })}
              <input type="hidden" name="MaritalStatus" id="MaritalStatus" />
            </div>
          </td>
        </tr>
        <tr>
          <td>
            Occupation - Exact Duties
            <br />
            <div className="hdf-table__cell">
              <Field
                name="JobTitle"
                type="text"
                component={renderField}
                label="JobTitle"
                style={{ width: 500 }}
              />
            </div>
          </td>
          <td>
            Nationality
            <div className="hdf-table__cell">
              <Field
                name="Nationality"
                type="text"
                component={renderField}
                label="Nationality"
                style={{ width: 200 }}
              />
            </div>
          </td>
          <td>
            <div className="hdf-table__header">Height (cm)</div>
            <div className="hdf-table__cell">
              <Field
                name="Height"
                type="text"
                component={renderField}
                label="Height"
                style={{ width: 50 }}
              />
            </div>
          </td>
          <td>
            <div className="hdf-table__header">Weight (kg)</div>
            <div className="hdf-table__cell">
              <Field
                name="Weight"
                type="text"
                component={renderField}
                label="Weight"
                style={{ width: 50 }}
              />
            </div>
          </td>
          <td className="hdf-table__header">
            Date of Birth
            <br />
            (dd/mm/yyyy)
            <div className="hdf-table__cell">
              {renderValue({
                fieldName: "BirthDate",
                fieldFormat: "date",
                dateFormat: "DD/MM/YYYY",
              })}
              <input type="hidden" name="BirthDate" id="BirthDate" />
            </div>
          </td>
          <td className="hdf-table__header">
            Date of Employment
            <br />
            (dd/mm/yyyy)
            <div className="hdf-table__cell">
              {renderValue({
                fieldName: "JoinDate",
                fieldFormat: "date",
                dateFormat: "DD/MM/YYYY",
              })}
              <input type="hidden" name="JoinDate" id="JoinDate" />
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <table>
      <tbody>
        <tr>
          <td>
            <div className="radio-group__inline">
              <strong>(2)&nbsp;&nbsp;&nbsp;&nbsp;DEPENDANTS COVERAGE:</strong>
              <Field name="DependantCoverage" component={renderField} type="radio" value="Yes" />
              <strong>YES</strong>
              &nbsp;&nbsp;&nbsp;
              <Field name="DependantCoverage" component={renderField} type="radio" value="No" />
              <strong>NO</strong>
            </div>
            <br />
            <strong>{"DEPENDANTS' INFORMATION"}</strong>
            <br />
            <span className="warning">
              Note: All Children must be below age 25, unmarried, unemployed and not serving
              National Service.
            </span>
          </td>
        </tr>
      </tbody>
    </table>
    <table className="hdf-table">
      <tbody>
        <tr>
          <td className="hdf-table__header hdf-table__header--bottom" rowSpan={2}>
            Relationship
            <br />
            to Employee
          </td>
          <td className="hdf-table__header hdf-table__header--bottom" rowSpan={2}>
            Name
          </td>
          <td className="hdf-table__header hdf-table__header--bottom" rowSpan={2}>
            Sex
            <br />
            (Male / Female)
          </td>
          <td className="hdf-table__header hdf-table__header--bottom" rowSpan={2}>
            NRIC / <br />
            Birth Certificate
          </td>
          <td className="hdf-table__header" colSpan={3}>
            Date of Birth
          </td>
          <td className="hdf-table__header hdf-table__header--bottom" rowSpan={2}>
            Height
            <br />
            (cm)
          </td>
          <td className="hdf-table__header hdf-table__header--bottom" rowSpan={2}>
            Weight
            <br />
            (kg)
          </td>
        </tr>
        <tr>
          <td className="hdf-table__header">Day</td>
          <td className="hdf-table__header">Month</td>
          <td className="hdf-table__header">Year</td>
        </tr>
        <tr>
          <td className="hdf-table__header">Spouse</td>
          <td id="RO_SpouseName" className="hdf-table__header">
            &nbsp;
            <input type="hidden" name="SpouseName" id="SpouseName" />
          </td>
          <td id="RO_SpouseGender" className="hdf-table__header">
            &nbsp;
            <input type="hidden" name="SpouseGender" id="SpouseGender" />
          </td>
          <td id="RO_SpouseIdentification" className="hdf-table__header">
            &nbsp;
            <input type="hidden" name="SpouseIdentification" id="SpouseIdentification" />
          </td>
          <td className="hdf-table__header" id="RO_SpouseBirthDateDay">
            &nbsp;
            <input type="hidden" name="SpouseBirthDate" id="SpouseBirthDate" />
          </td>
          <td className="hdf-table__header" id="RO_SpouseBirthDateMonth" />
          <td className="hdf-table__header" id="RO_SpouseBirthDateYear" />
          <td className="hdf-table__header">
            <Field
              name="SpouseHeight"
              type="text"
              component={renderField}
              label="SpouseHeight"
              style={{ width: 50 }}
            />
          </td>
          <td className="hdf-table__header">
            <Field
              name="SpouseWeight"
              type="text"
              component={renderField}
              label="SpouseWeight"
              style={{ width: 50 }}
            />
          </td>
        </tr>
        <tr>
          <td className="hdf-table__header">
            1<sup>st</sup> Child
          </td>
          <td id="RO_FirstChildName" className="hdf-table__header">
            &nbsp;
            <input type="hidden" name="FirstChildName" id="FirstChildName" />
          </td>
          <td id="RO_FirstChildGender" className="hdf-table__header">
            &nbsp;
            <input type="hidden" name="FirstChildGender" id="FirstChildGender" />
          </td>
          <td id="RO_FirstChildIdentification" className="hdf-table__header">
            &nbsp;
            <input type="hidden" name="FirstChildIdentification" id="FirstChildIdentification" />
          </td>
          <td className="hdf-table__header" id="RO_FirstChildBirthDateDay">
            &nbsp;
            <input type="hidden" name="FirstChildBirthDate" id="FirstChildBirthDate" />
          </td>
          <td className="hdf-table__header" id="RO_FirstChildBirthDateMonth" />
          <td className="hdf-table__header" id="RO_FirstChildBirthDateYear" />
          <td className="hdf-table__header">
            <Field
              name="FirstChildHeight"
              type="text"
              component={renderField}
              label="FirstChildHeight"
              style={{ width: 50 }}
            />
          </td>
          <td className="hdf-table__header">
            <Field
              name="FirstChildWeight"
              type="text"
              component={renderField}
              label="FirstChildWeight"
              style={{ width: 50 }}
            />
          </td>
        </tr>
        <tr>
          <td className="hdf-table__header">
            2<sup>nd</sup> Child
          </td>
          <td id="RO_SecondChildName" className="hdf-table__header">
            &nbsp;
            <input type="hidden" name="SecondChildName" id="SecondChildName" />
          </td>
          <td id="RO_SecondChildGender" className="hdf-table__header">
            &nbsp;
            <input type="hidden" name="SecondChildGender" id="SecondChildGender" />
          </td>
          <td id="RO_SecondChildIdentification" className="hdf-table__header">
            &nbsp;
            <input type="hidden" name="SecondChildIdentification" id="SecondChildIdentification" />
          </td>
          <td className="hdf-table__header" id="RO_SecondChildBirthDateDay">
            &nbsp;
            <input type="hidden" name="SecondChildBirthDate" id="SecondChildBirthDate" />
          </td>
          <td className="hdf-table__header" id="RO_SecondChildBirthDateMonth" />
          <td className="hdf-table__header" id="RO_SecondChildBirthDateYear" />
          <td className="hdf-table__header">
            <Field
              name="SecondChildHeight"
              type="text"
              component={renderField}
              label="SecondChildHeight"
              style={{ width: 50 }}
            />
          </td>
          <td className="hdf-table__header">
            <Field
              name="SecondChildWeight"
              type="text"
              component={renderField}
              label="SecondChildWeight"
              style={{ width: 50 }}
            />
          </td>
        </tr>
        <tr>
          <td className="hdf-table__header">
            3<sup>rd</sup> Child
          </td>
          <td id="RO_ThirdChildName" className="hdf-table__header">
            &nbsp;
            <input type="hidden" name="ThirdChildName" id="ThirdChildName" />
          </td>
          <td id="RO_ThirdChildGender" className="hdf-table__header">
            &nbsp;
            <input type="hidden" name="ThirdChildGender" id="ThirdChildGender" />
          </td>
          <td id="RO_ThirdChildIdentification" className="hdf-table__header">
            &nbsp;
            <input type="hidden" name="ThirdChildIdentification" id="ThirdChildIdentification" />
          </td>
          <td className="hdf-table__header" id="RO_ThirdChildBirthDateDay">
            &nbsp;
            <input type="hidden" name="ThirdChildBirthDate" id="ThirdChildBirthDate" />
          </td>
          <td className="hdf-table__header" id="RO_ThirdChildBirthDateMonth" />
          <td className="hdf-table__header" id="RO_ThirdChildBirthDateYear" />
          <td className="hdf-table__header">
            <Field
              name="ThirdChildHeight"
              type="text"
              component={renderField}
              label="ThirdChildHeight"
              style={{ width: 50 }}
            />
          </td>
          <td className="hdf-table__header">
            <Field
              name="ThirdChildWeight"
              type="text"
              component={renderField}
              label="ThirdChildWeight"
              style={{ width: 50 }}
            />
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <table>
      <tbody>
        <tr>
          <td>
            <strong>(3)</strong>
            &nbsp;&nbsp;&nbsp;&nbsp;
          </td>
          <td>Have you and/or your spouse smoked during the past 12 months?</td>
          <td className="radio-group__inline">
            <Field name="EmpSmokes" component={renderField} type="radio" value="Yes" />
            Yes
            <Field name="EmpSmokes" component={renderField} type="radio" value="No" />
            No
          </td>
        </tr>
        <tr>
          <td>&nbsp;</td>
          <td colSpan={2}>
            If <strong>YES</strong>, please provide details below:
          </td>
        </tr>
        <tr>
          <td colSpan={3}>
            <table className="hdf-table">
              <tbody>
                <tr>
                  <td className="hdf-table__header">Name of Person</td>
                  <td className="hdf-table__header">No. of years smoking</td>
                  <td className="hdf-table__header">No. of sticks per day</td>
                </tr>
                <tr>
                  <td className="hdf-table__cell--center">
                    <Field
                      name="EmpSmokerName"
                      type="text"
                      component={renderField}
                      label="EmpSmokerName"
                      style={{ width: 350 }}
                    />
                  </td>
                  <td className="hdf-table__cell--center">
                    <Field
                      name="EmpSmokeNoOfYears"
                      type="text"
                      component={renderField}
                      label="EmpSmokeNoOfYears"
                      style={{ width: 50 }}
                    />
                  </td>
                  <td className="hdf-table__cell--center">
                    <Field
                      name="EmpSmokeQuantity"
                      type="text"
                      component={renderField}
                      label="EmpSmokeQuantity"
                      style={{ width: 50 }}
                    />
                  </td>
                </tr>
                <tr>
                  <td className="hdf-table__cell--center">
                    <Field
                      name="SpouseSmokerName"
                      type="text"
                      component={renderField}
                      label="SpouseSmokerName"
                      style={{ width: 350 }}
                    />
                  </td>
                  <td className="hdf-table__cell--center">
                    <Field
                      name="SpouseSmokeNoOfYears"
                      type="text"
                      component={renderField}
                      label="SpouseSmokeNoOfYears"
                      style={{ width: 50 }}
                    />
                  </td>
                  <td className="hdf-table__cell--center">
                    <Field
                      name="SpouseSmokeQuantity"
                      type="text"
                      component={renderField}
                      label="SpouseSmokeQuantity"
                      style={{ width: 50 }}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td className="hdf-table__cell">
            <strong>(4)</strong>
            &nbsp;&nbsp;&nbsp;&nbsp;
          </td>
          <td className="hdf-table__cell">
            Do you and/or your spouse consume any beer, wine, alcohol or other stimulants?
          </td>
          <td className="radio-group__inline">
            <Field name="EmpAlcohol" component={renderField} type="radio" value="Yes" />
            Yes
            <Field name="EmpAlcohol" component={renderField} type="radio" value="No" />
            No
          </td>
        </tr>
        <tr>
          <td>&nbsp;</td>
          <td colSpan={2}>
            If <strong>YES</strong>, please provide details below:
          </td>
        </tr>
        <tr>
          <td colSpan={3}>
            <table className="hdf-table">
              <tbody>
                <tr>
                  <td className="hdf-table__header">Name of Person</td>
                  <td className="hdf-table__header">Type of alcohol - beer, wine or liquor etc</td>
                  <td className="hdf-table__header">
                    Quantity per week (number of units or in milliliter / pint)
                  </td>
                </tr>
                <tr>
                  <td>
                    <Field
                      name="EmpAlcoholName"
                      type="text"
                      component={renderField}
                      label="EmpAlcoholName"
                      style={{ width: 350 }}
                    />
                  </td>
                  <td className="hdf-table__cell--center">
                    <Field
                      name="EmpAlcoholType"
                      type="text"
                      component={renderField}
                      label="EmpAlcoholType"
                      style={{ width: 100 }}
                    />
                  </td>
                  <td className="hdf-table__cell--center">
                    <Field
                      name="EmpAlcoholQuantity"
                      type="text"
                      component={renderField}
                      label="EmpAlcoholQuantity"
                      style={{ width: 50 }}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <Field
                      name="SpouseAlcoholName"
                      type="text"
                      component={renderField}
                      label="SpouseAlcoholName"
                      style={{ width: 350 }}
                    />
                  </td>
                  <td className="hdf-table__cell--center">
                    <Field
                      name="SpouseAlcoholType"
                      type="text"
                      component={renderField}
                      label="SpouseAlcoholType"
                      style={{ width: 100 }}
                    />
                  </td>
                  <td className="hdf-table__cell--center">
                    <Field
                      name="SpouseAlcoholQuantity"
                      type="text"
                      component={renderField}
                      label="SpouseAlcoholQuantity"
                      style={{ width: 50 }}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td className="hdf-table__cell">
            <strong>(5)</strong>
            &nbsp;&nbsp;&nbsp;&nbsp;
          </td>
          <td className="hdf-table__cell">
            {[
              "Have any of your and/or your spouse's family members (biological ",
              "parents and siblings) died or ever suffered from",
            ].join("")}
            <br />
            any cancer (specify type of cancer), heart disease, stroke, high blood pressure,
            diabetes, kidney diseases, mental disorder,
            <br />
            {[
              "alzheimer's disease, motor neuron disease, multiple sclerosis, ",
              "parkinson's disease, or any hereditary disease or",
            ].join("")}
            <br />
            there is more than one family members suffering from the same serious illness?
          </td>
          <td className="radio-group__inline">
            <Field
              name="EmpGeneticMedicalCondition"
              component={renderField}
              type="radio"
              value="Yes"
            />
            Yes
            <Field
              name="EmpGeneticMedicalCondition"
              component={renderField}
              type="radio"
              value="No"
            />
            No
          </td>
        </tr>
        <tr>
          <td>&nbsp;</td>
          <td colSpan={2}>
            If <strong>YES</strong>, please provide details below:
          </td>
        </tr>
        <tr>
          <td colSpan={3}>
            <table className="hdf-table">
              <tbody>
                <tr>
                  <td className="hdf-table__header">Name of Life to be assured</td>
                  <td className="hdf-table__header">Relationship to the life to be assured</td>
                  <td className="hdf-table__header">Diagnosis / Cause of Death</td>
                  <td className="hdf-table__header">Age At Diagnosis</td>
                </tr>
                <tr>
                  <td>
                    <Field
                      name="AssuredLifeName1"
                      type="text"
                      component={renderField}
                      label="AssuredLifeName1"
                      style={{ width: 350 }}
                    />
                  </td>
                  <td className="hdf-table__header">
                    <Field
                      name="ParentsSiblings1Relationship"
                      type="text"
                      component={renderField}
                      label="ParentsSiblings1Relationship"
                      style={{ width: 100 }}
                    />
                  </td>
                  <td className="hdf-table__header">
                    <Field
                      component="textarea"
                      multiLine
                      boxed
                      name="ParentsSiblings1MedicalCondition"
                      id="ParentsSiblings1MedicalCondition"
                      rows={3}
                      cols={40}
                      defaultValue={""}
                    />
                  </td>
                  <td className="hdf-table__header">
                    <Field
                      name="ParentsSiblings1AgeAtDiagnosis"
                      type="text"
                      component={renderField}
                      label="ParentsSiblings1AgeAtDiagnosis"
                      style={{ width: 50 }}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <Field
                      name="AssuredLifeName2"
                      type="text"
                      component={renderField}
                      label="AssuredLifeName2"
                      style={{ width: 350 }}
                    />
                  </td>
                  <td className="hdf-table__header">
                    <Field
                      name="ParentsSiblings2Relationship"
                      type="text"
                      component={renderField}
                      label="ParentsSiblings2Relationship"
                      style={{ width: 100 }}
                    />
                  </td>
                  <td className="hdf-table__header">
                    <Field
                      component="textarea"
                      multiLine
                      boxed
                      name="ParentsSiblings2MedicalCondition"
                      id="ParentsSiblings2MedicalCondition"
                      rows={3}
                      cols={40}
                      defaultValue={""}
                    />
                  </td>
                  <td className="hdf-table__header">
                    <Field
                      name="ParentsSiblings2AgeAtDiagnosis"
                      type="text"
                      component={renderField}
                      label="ParentsSiblings2AgeAtDiagnosis"
                      style={{ width: 50 }}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <Field
                      name="AssuredLifeName3"
                      type="text"
                      component={renderField}
                      label="AssuredLifeName3"
                      style={{ width: 350 }}
                    />
                  </td>
                  <td className="hdf-table__header">
                    <Field
                      name="ParentsSiblings3Relationship"
                      type="text"
                      component={renderField}
                      label="ParentsSiblings3Relationship"
                      style={{ width: 100 }}
                    />
                  </td>
                  <td className="hdf-table__header">
                    <Field
                      component="textarea"
                      multiLine
                      boxed
                      name="ParentsSiblings3MedicalCondition"
                      id="ParentsSiblings3MedicalCondition"
                      rows={3}
                      cols={40}
                      defaultValue={""}
                    />
                  </td>
                  <td className="hdf-table__header">
                    <Field
                      name="ParentsSiblings3AgeAtDiagnosis"
                      type="text"
                      component={renderField}
                      label="ParentsSiblings3AgeAtDiagnosis"
                      style={{ width: 50 }}
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <Field
                      name="AssuredLifeName4"
                      type="text"
                      component={renderField}
                      label="AssuredLifeName4"
                      style={{ width: 350 }}
                    />
                  </td>
                  <td className="hdf-table__header">
                    <Field
                      name="ParentsSiblings4Relationship"
                      type="text"
                      component={renderField}
                      label="ParentsSiblings4Relationship"
                      style={{ width: 100 }}
                    />
                  </td>
                  <td className="hdf-table__header">
                    <Field
                      component="textarea"
                      multiLine
                      boxed
                      name="ParentsSiblings4MedicalCondition"
                      id="ParentsSiblings4MedicalCondition"
                      rows={3}
                      cols={40}
                      defaultValue={""}
                    />
                  </td>
                  <td className="hdf-table__header">
                    <Field
                      name="ParentsSiblings4AgeAtDiagnosis"
                      type="text"
                      component={renderField}
                      label="ParentsSiblings4AgeAtDiagnosis"
                      style={{ width: 100 }}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td className="hdf-table__cell">
            <strong>(6)</strong>
            &nbsp;&nbsp;&nbsp;&nbsp;
          </td>
          <td className="hdf-table__cell">
            Have you and/or has any person named in this Form ever had any health or life insurance
            application declined, postponed or accepted on special terms?
          </td>
          <td className="radio-group__inline">
            <Field name="EmpExclusions" component={renderField} type="radio" value="Yes" />
            Yes
            <Field name="EmpExclusions" component={renderField} type="radio" value="No" />
            No
          </td>
        </tr>
        <tr>
          <td>&nbsp;</td>
          <td colSpan={2}>
            If <strong>YES</strong>, please provide full details below:
          </td>
        </tr>
        <tr>
          <td colSpan={3}>
            <Field
              component="textarea"
              multiLine
              boxed
              name="EmpExclusionsDetails"
              id="EmpExclusionsDetails"
              rows={5}
              cols={60}
              defaultValue={""}
            />
          </td>
        </tr>
        <tr>
          <td className="hdf-table__cell">
            <strong>(7)</strong>
            &nbsp;&nbsp;&nbsp;&nbsp;
          </td>
          <td className="hdf-table__cell">
            Do you and/or does any person named in this Form engage in any hazardous activity or
            occupation such as
            <br />
            flying, scuba / skin diving, motor racing, road and track cycling etc.?
          </td>
          <td className="radio-group__inline">
            <Field name="EmpAdventure" component={renderField} type="radio" value="Yes" />
            Yes
            <Field name="EmpAdventure" component={renderField} type="radio" value="No" />
            No
          </td>
        </tr>
        <tr>
          <td>&nbsp;</td>
          <td colSpan={2}>
            <span>
              If <strong>YES</strong>
            </span>
            , please specify and provide details such as locations, frequency, etc.
          </td>
        </tr>
        <tr>
          <td colSpan={3}>
            <Field
              component="textarea"
              multiLine
              boxed
              name="EmpAdventureDetails"
              id="EmpAdventureDetails"
              rows={5}
              cols={60}
              defaultValue={""}
            />
          </td>
        </tr>
        <tr>
          <td className="hdf-table__cell">
            <strong>(8)</strong>
            &nbsp;&nbsp;&nbsp;&nbsp;
          </td>
          <td className="hdf-table__cell" colSpan={2}>
            <strong>HEALTH QUESTIONNAIRE (Please tick the boxes)</strong>
          </td>
        </tr>
      </tbody>
    </table>
    <table className="normal-padded">
      <thead>
        <tr>
          <th rowSpan={2} colSpan={2}>
            A) Have you and/or has any person named in this Form ever had or been told to have or
            been treated for:
          </th>
          <th colSpan={2}>Employee</th>
          <th colSpan={2}>Spouse</th>
          <th colSpan={2}>
            1<sup>st</sup> Child
          </th>
          <th colSpan={2}>
            2<sup>nd</sup> Child
          </th>
          <th colSpan={2}>
            3<sup>rd</sup> Child
          </th>
        </tr>
        <tr>
          <th>Yes</th>
          <th>No</th>
          <th>Yes</th>
          <th>No</th>
          <th>Yes</th>
          <th>No</th>
          <th>Yes</th>
          <th>No</th>
          <th>Yes</th>
          <th>No</th>
        </tr>
      </thead>
      <tbody>
        <RadioButtonGroupRow
          questionDesc="Epilepsy, fits, stroke, paralysis, weakness of limb, prolonged headache, unconsciousness, nervous breakdown, depression, or any other nervous / mental disorders or disorders of the brain?"
          questionBullet="a)"
          questionId="MentalDisorders"
          options={["Yes", "No"]}
          columns={["Emp", "Dep1", "Dep2", "Dep3", "Dep4"]}
        />
        <RadioButtonGroupRow
          questionDesc="Diabetes, thyroid disorder or any other disorders of the endocrine system?"
          questionBullet="b)"
          questionId="EndocrineDisorder"
          options={["Yes", "No"]}
          columns={["Emp", "Dep1", "Dep2", "Dep3", "Dep4"]}
        />
        <RadioButtonGroupRow
          questionDesc="Ear discharge, nose bleeds, impaired sight, hearing or speech or any other disorders of the ear, eye, nose or throat?"
          questionBullet="c)"
          questionId="HearingAndSight"
          options={["Yes", "No"]}
          columns={["Emp", "Dep1", "Dep2", "Dep3", "Dep4"]}
        />
        <RadioButtonGroupRow
          questionDesc="Asthma, blood spitting, persistent cough, pleurisy, tuberculosis or any other disorders of the lungs or respiratory system?"
          questionBullet="d)"
          questionId="LungDisorder"
          options={["Yes", "No"]}
          columns={["Emp", "Dep1", "Dep2", "Dep3", "Dep4"]}
        />
        <RadioButtonGroupRow
          questionDesc="Raised cholesterol, high or low blood pressure, coronary artery disease, heart attack, rheumatic fever, palpitation, breathlessness, chest discomfort or pain, disease of or any other disorders of the heart or the blood vessels?"
          questionBullet="e)"
          questionId="HeartDisorder"
          options={["Yes", "No"]}
          columns={["Emp", "Dep1", "Dep2", "Dep3", "Dep4"]}
        />
        <RadioButtonGroupRow
          questionDesc="Jaundice, hepatitis or carrier, ulcer, hernia, chronic indigestion / diarrhoea, blood in stools, fistula, piles or any other disorders of the stomach, liver, gall bladder, intestines or digestive organ?"
          questionBullet="f)"
          questionId="GallbladderDisorder"
          options={["Yes", "No"]}
          columns={["Emp", "Dep1", "Dep2", "Dep3", "Dep4"]}
        />
        <RadioButtonGroupRow
          questionDesc="Protein, blood, pus or sugar in urine, renal stone or any other disorders of the kidney, bladder or genital organs?"
          questionBullet="g)"
          questionId="KidneyDisorder"
          options={["Yes", "No"]}
          columns={["Emp", "Dep1", "Dep2", "Dep3", "Dep4"]}
        />
        <RadioButtonGroupRow
          questionDesc="Arthritis, slipped disc, recurrent back pain, gout or any other disorders of the muscle, spine, limbs or joints or severe injury?"
          questionBullet="h)"
          questionId="PhysicalInjury"
          options={["Yes", "No"]}
          columns={["Emp", "Dep1", "Dep2", "Dep3", "Dep4"]}
        />
        <RadioButtonGroupRow
          questionDesc="Sexually transmitted diseases such as gonorrhoea, syphilis, non-specific urethritis, any other venereal disease, AIDS or AIDS related condition or infection with any Human Immunodeficiency Virus (HIV)?"
          questionBullet="i)"
          questionId="SexualDisease"
          options={["Yes", "No"]}
          columns={["Emp", "Dep1", "Dep2", "Dep3", "Dep4"]}
        />
        <RadioButtonGroupRow
          questionDesc="Cancer, tumour, cyst, growth of any kind (please specify cancerous / non-cancerous and site of the growth/organ involved)?"
          questionBullet="j)"
          questionId="Cancer"
          options={["Yes", "No"]}
          columns={["Emp", "Dep1", "Dep2", "Dep3", "Dep4"]}
        />
        <RadioButtonGroupRow
          questionDesc="Gynaecological disorders such as endometriosis, ovarian growth, fibroid, irregular menstrual bleeding, abnormal pap smear results etc?"
          questionBullet="k)"
          questionId="FemaleDisease"
          options={["Yes", "No"]}
          columns={["Emp", "Dep1", "Dep2", "Dep3", "Dep4"]}
        />
        <RadioButtonGroupRow
          questionDesc="Anaemia, any other disorders of the blood, congenital anomalies, physical defects or any other illnesses, disorders not mentioned above?"
          questionBullet="l)"
          questionId="OtherDisorder"
          options={["Yes", "No"]}
          columns={["Emp", "Dep1", "Dep2", "Dep3", "Dep4"]}
        />
        <RadioButtonGroupRow
          questionDesc="Are you and/or is any person named in this Form currently taking any medicine / addictive drugs or receiving medical treatment or on follow up by doctor or considering receiving medical attention?"
          questionBullet="B)"
          questionId="MedTreatment"
          options={["Yes", "No"]}
          columns={["Emp", "Dep1", "Dep2", "Dep3", "Dep4"]}
          style={{
            fontWeight: "bold",
            textAlign: "left",
            borderBottom: "1px solid #000",
          }}
        />
        <RadioButtonGroupRow
          questionDesc="In the past 5 years, have you and/or has any person named in this Form ever been hospitalised or had a surgical operation or an X-ray, ultrasound, CT scan, biopsy, angiogram, electrocardiogram (ECG), HIV-antibody, blood or urine test, or other medical tests carried out for investigative purpose?"
          questionBullet="C)"
          questionId="Diagnosis"
          options={["Yes", "No"]}
          columns={["Emp", "Dep1", "Dep2", "Dep3", "Dep4"]}
          style={{
            fontWeight: "bold",
            textAlign: "left",
            borderBottom: "1px solid #000",
          }}
        />
      </tbody>
    </table>
    <br />
    <div className="warning">
      <strong>
        If any of the answers to (8) - Health Questionnaire is YES, please provide details below and
        attach a copy of the medical report and medical test report if available. If more
        information needs to be provided, please attach a separate sheet with signatures and date.
      </strong>
    </div>
    <table className="hdf-table">
      <tbody>
        <tr>
          <td rowSpan={2} className="hdf-table__header">
            Question No
          </td>
          <td rowSpan={2} className="hdf-table__header">
            Name of Person
          </td>
          <td rowSpan={2} className="hdf-table__header">
            Name of medical condition, medical test results, reason for undertaking the test &
            treatment etc
          </td>
          <td colSpan={2} className="hdf-table__header">
            Duration of condition
          </td>
          <td rowSpan={2} className="hdf-table__header">
            Name & Address of Doctor / Hospital
          </td>
        </tr>
        <tr>
          <td className="hdf-table__header">From</td>
          <td className="hdf-table__header">To</td>
        </tr>
        {moreInfoData &&
          moreInfoData.rows &&
          moreInfoData.rows.map((row, idx) => (
            <GroupTableRowField key={idx} data={moreInfoData} index={row} />
          ))}
      </tbody>
    </table>
    <br />
    <table>
      <tbody>
        <tr>
          <td colSpan={12}>
            <div className="header">Declaration</div>
            {[
              "I / We declare, represent to and warrant with Tokio Marine Life ",
              'Insurance Singapore Ltd ("TMLS") that to the best of my / our ',
              "knowledge and belief that all the information given above is ",
              "true, accurate and complete as at the date of this Form. I / We ",
              "agree that this Form shall form part of the contract of ",
              "insurance to be issued under the Policy. I / We understand the ",
              "Policy shall not become effective unless it has been accepted ",
              "and confirmed in writing by TMLS.",
            ].join("")}
            <br />
            <br />I / We agree to inform TMLS immediately if there is any material change to the
            information under this Form including the state of my / our health and/or activities
            between the date of this Form and the date when full insurance coverage is provided by
            TMLS. I / We understand that the terms of accepting me / us as a risk for insurance
            coverage may vary according to such information received by TMLS.
            <br />
            <br />I / We authorise TMLS to give information under this Form to the servicing
            insurance intermediary, adviser, administrator and relevant parties in connection with
            the Policy for the purpose of obtaining and administering my / our insurance coverage.
            <br />
            <br />
            <div className="warning">
              If a material fact is not disclosed in this Form, any policy issued by TMLS may not be
              valid. If you are in doubt as to whether a fact is material, you are advised to
              disclose it. This includes any information that you may have provided to your adviser
              but was not included here. Please take all necessary actions to ensure you are fully
              satisfied with the information declared in this Form.
            </div>
            <br />
            <br />
            <div className="box">
              <span className="header">
                Applicable to any of the following plans if you are participating in the plan, in
                full or in part, at your own discretion
              </span>
              :<br />
              Dread Disease, Disability Income, Deluxe Medical, Hospital & Surgical, Catastrophic
              Medical, Major Medical & Outpatient Insurance
              <br />
              {[
                "I / We confirm that I / we have read and understood the ",
                'contents of (1) "Your Guide to Health Insurance" and (2) ',
                '"Product Summary".',
              ].join("")}
            </div>
            <br />
            <span className="header">Personal Data Notice</span>
            {[
              ": I / We agree and consent that Tokio Marine Life Insurance ",
              'Singapore Ltd. ("Company") may collect, use, process and ',
              "disclose the personal data in accordance with the terms and ",
              "conditions as stated in the insurance application form and / or ",
              "the Company's Data Protection Policy available at",
            ].join("")}{" "}
            <a href="http://www.tokiomarine-life.sg" target="_blank" rel="noopener noreferrer">
              www.tokiomarine-life.sg
            </a>
            , which I / we have read, understood and agreed to the same.
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <CheckboxField validate={validateRequired} name="declaration" id="declaration">
      <strong>I have read and accept this declaration</strong>
    </CheckboxField>
    <center>
      <table className="signature">
        <tbody>
          <tr>
            <td className="signature__underline" id="RO_CompletedBy" />
            <td style={{ width: 100 }}>&nbsp;</td>
            <td className="signature__underline" id="RO_CompletedOn" />
          </tr>
          <tr>
            <td>Signature of Life To Be Assured (Employee)</td>
            <td>&nbsp;</td>
            <td>Date (dd/mm/yy)</td>
          </tr>
        </tbody>
      </table>
    </center>
    <br />
    <table>
      <tbody>
        <tr>
          <td>
            <img
              alt="Tokio Marine Insurance Group Company Name"
              src={require("assets/client/tokiomarine/tmcompanyname.jpg")}
            />
          </td>
          <td>(Company Reg. No.: 194800055D)</td>
        </tr>
      </tbody>
    </table>
    <div>
      20 McCallum Street, #07-01 Tokio Marine Centre, Singapore 069046&nbsp;&nbsp;&nbsp;Tel: 6592
      6100&nbsp;&nbsp;&nbsp;Fax: 6223 9120&nbsp;&nbsp;&nbsp;
      <a href="http://www.tokiomarine-life.sg" target="_blank" rel="noopener noreferrer">
        www.tokiomarine-life.sg
      </a>
      <div style={{ textAlign: "right" }}>V2013</div>
    </div>
  </div>
);

StyledForm.propTypes = {
  renderValue: PropTypes.func.isRequired,
};

export default StyledForm;



// WEBPACK FOOTER //
// ./components/employee/hdf-forms/Tokiomarine/StyledForm.js